import { Button } from '@cannect/new-components/atoms'
import { useSkipSubscription } from '@cannect/services/resources/recurrency/hooks'
import { formatApiDate } from '@cannect/services/resources/recurrency/helpers'
import type { SubscriptionDetail } from '@cannect/services/resources/recurrency/types'
import { subscriptionsCopy } from '../copy'
import { useSubscriptionAction } from '../hooks/useSubscriptionAction'
import { DialogShell } from './DialogShell'

const copy = subscriptionsCopy.skip

type Props = { detail: SubscriptionDetail; open: boolean; onOpenChange: (open: boolean) => void }

export const SkipDialog = ({ detail, open, onOpenChange }: Props) => {
  const action = useSubscriptionAction({ detail, mutation: useSkipSubscription(detail.id), event: 'recurrency_skip' })
  const from = formatApiDate(detail.currentCycle?.scheduledAt || detail.nextChargeAt, 'dd/MM')
  const next = detail.skipNextChargeAt ? formatApiDate(detail.skipNextChargeAt, 'dd/MM') : ''

  return (
    <DialogShell
      open={open}
      onOpenChange={onOpenChange}
      title={copy.title}
      description={next ? copy.body(from, next) : copy.bodyNoNext(from)}
      footer={
        <>
          <Button variant="outline_light" onClick={() => onOpenChange(false)}>
            {subscriptionsCopy.buttons.back}
          </Button>
          <Button
            isLoading={action.isPending}
            onClick={async () => {
              if (await action.run(undefined as void)) onOpenChange(false)
            }}>
            {copy.confirm}
          </Button>
        </>
      }
    />
  )
}
